import React from 'react';

const HeroSection = () => {
    return (
        <div className="relative w-full h-80 md:h-96 overflow-hidden">
            {/* Background - Dark with subtle pattern */}
            <div className="absolute inset-0 bg-gray-800">
                {/* Subtle grid pattern overlay */}
                <div className="absolute inset-0 opacity-10 bg_Image_Portfolio">
                    <div className="h-full w-full" style={{
                        backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.1) 1px, transparent 0)',
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>

                {/* Flowing wave pattern on the right */}
                <div className="absolute right-0 top-0 h-full w-64 opacity-5">
                    <svg viewBox="0 0 200 400" className="h-full w-full">
                        <path
                            d="M0,0 Q50,100 0,200 T0,400 L200,400 L200,0 Z"
                            fill="rgba(255,255,255,0.1)"
                        />
                        <path
                            d="M20,0 Q70,120 20,240 T20,400 L200,400 L200,0 Z"
                            fill="rgba(255,255,255,0.05)"
                        />
                    </svg>
                </div>
            </div>

            {/* Blue geometric overlay - positioned to match the image */}
            <div className="absolute inset-0 overflow-hidden">
                {/* Main blue diagonal shape */}
                <div
                    className="absolute bg-blue-600 opacity-20"
                    style={{
                        width: '120%',
                        height: '200%',
                        top: '-50%',
                        right: '-60%',
                        transform: 'rotate(-15deg)',
                        clipPath: 'polygon(0 40%, 100% 0, 100% 60%, 0 100%)'
                    }}
                ></div>

                {/* Secondary blue accent */}
                <div
                    className="absolute bg-blue-500 opacity-30"
                    style={{
                        width: '100%',
                        height: '150%',
                        top: '-25%',
                        right: '-40%',
                        transform: 'rotate(-10deg)',
                        clipPath: 'polygon(0 60%, 100% 20%, 100% 80%, 0 100%)'
                    }}
                ></div>
            </div>

            {/* Content */}
            <div className="relative z-10 flex flex-col justify-center containers items-start h-full px-6 md:px-12 text-white">
                {/* Breadcrumb */}


                {/* Main heading */}
                <h1 className="text-4xl md:text-6xl font-bold leading-tight">
                    Portfolio
                </h1>
                {/* Optional subtitle */}
                <div className="mt-4 w-12 h-1 bg-blue-400"></div>
                <p className='mt-3 w-100 lg:w-[50%]  md:w-[60%]'>
                    Our Inward to Delivery system is a comprehensive solution built specifically for textile dyeing and printing units. It provides complete visibility across every stage of production—from raw material entry to final dispatch
                </p>
            </div>


        </div>
    );
};

export default HeroSection;